import { render, staticRenderFns } from "./OeText.vue?vue&type=template&id=372f06a2&scoped=true&"
import script from "./OeText.vue?vue&type=script&lang=js&"
export * from "./OeText.vue?vue&type=script&lang=js&"
import style0 from "./OeText.vue?vue&type=style&index=0&id=372f06a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372f06a2",
  null
  
)

export default component.exports